module.exports = __webpack_public_path__ + "static/media/clydeKimScooter55.50b760ba.png";